import { Tabs, Box, Flex, Button, Text, Stack } from "@mantine/core";
import { FaCheck, FaQuestion } from "react-icons/fa";
import { TForm, TQuestion } from "../../../types/Aula";
import { useTranslation } from "react-i18next";
import { QuestionRenderer } from "../QuestionRenderer";
import { UseFormReturnType } from "@mantine/form";
import { useState } from "react";
import { isAnswered } from "../../../utils/isAnswered";

export const QuizTabs = ({
  questions,
  form,
}: {
  questions: TQuestion[];
  form: UseFormReturnType<TForm>;
}) => {
  const [activeTab, setActiveTab] = useState<number>(0);
  const { t } = useTranslation();

  return (
    <Tabs value={activeTab.toString()} onChange={(value) => setActiveTab(Number(value))} orientation="vertical" placement="right">
      <Box w="20vw">
        <Tabs.List>
          {questions.map((question, index) => (
            <Flex
              key={`list_${question.id}`}
              align="center"
              gap="sm"
              onClick={() => setActiveTab(index)}
              bg={activeTab === index ? "#f0f0f0" : "transparent"}
              p="xs"
              style={{ cursor: "pointer" }}
            >
              {isAnswered(form, question.id) ? <FaCheck size="12" color="green" /> : <FaQuestion size="12" color="gray" />}
              <Text size="xs">{`Pregunta ${index + 1}`}</Text>
            </Flex>
          ))}
        </Tabs.List>
      </Box>
      <Box w="80vw" p="md" pos="relative" pb="60px">
        {questions.map((question, index) => (
          <Tabs.Panel
            key={`panel_${question.id}`}
            value={index.toString()}
          >
            <Stack align="flex-start" gap="md">
              <Text ta="justify">{question.description}</Text>
              <QuestionRenderer
                question={question}
                form={form}
                timeLeft={null}
              />
            </Stack>
          </Tabs.Panel>
        ))}
        <Flex
          justify="flex-end"
          align="center"
          gap="xs"
          bottom="10px"
          right="10px"
          pos="absolute"
        >
          {activeTab > 0 && (
            <Button
              variant="outline"
              onClick={() => setActiveTab(activeTab - 1)}
            >
              {t("actions.back")}
            </Button>
          )}
          {activeTab < questions.length - 1 ? (
            <Button
              variant="outline"
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.preventDefault();
                setActiveTab(activeTab + 1);
              }}
            >
              {t("actions.next")}
            </Button>
          ) : (
            <Button type="submit">{t("actions.submit")}</Button>
          )}
        </Flex>
      </Box>
    </Tabs>
  );
};
